import axios from 'axios'
import { navigate } from "svelte-routing";

export function setupAxios() {
    axios.defaults.withCredentials = true
    axios.interceptors.response.use(undefined, error => {
        onRequestError(error)
        return Promise.reject(error.response)
    })
}

function onRequestError(error) {
    const response = error.response
    if (response && response.status === 401) {
        navigate("/login")
    }
}
